
export default {
  methods:{
    mixin_route_guard(context) {
      return context.$auth.isAuthenticated
    },
  }
}